const dropdowns = new Set();
let listenerAttached = false;

function ensureListener() {
  if (listenerAttached) return;
  listenerAttached = true;
  document.addEventListener('click', (e) => {
    dropdowns.forEach((dd) => {
      if (!dd.contains(e.target)) {
        dd.classList.remove('open');
      }
    });
  });
}

export function registerDropdown(el) {
  dropdowns.add(el);
  ensureListener();
}

export function toggleDropdown(el) {
  const isOpen = el.classList.contains('open');
  closeAllDropdowns();
  if (!isOpen) {
    el.classList.add('open');
  }
}

export function closeAllDropdowns() {
  dropdowns.forEach((dd) => dd.classList.remove('open'));
}
